export default "__VITE_ASSET__D6xxy9Qh__"